// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_getLibraryDocGroup = (path: TSpecPathGetLibraryDocGroup) => {
  let res = "/library/docs/:libraryDocId/group";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_getLibraryDocGroup = RequestHandler<TSpecPathGetLibraryDocGroup, any, TSpecBodyGetLibraryDocGroup, TSpecQueryGetLibraryDocGroup, {}>;

export interface TSpecPathGetLibraryDocGroup { libraryDocId: string; }

export interface TSpecBodyGetLibraryDocGroup {}

export interface TSpecQueryGetLibraryDocGroup {
  AppVersion?: string;
  AppUser?: string;
}
